<span class="flex-none flex items-center justify-center">
	<ng-content select="[icon]"></ng-content>
</span>

<span class="flex-auto truncate flex items-center justify-start box-border" [ngClass]="textClass">
	<ng-content></ng-content>
</span>
